import script from "./AdminBooks.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBooks.vue?vue&type=script&setup=true&lang=js"

import "./AdminBooks.vue?vue&type=style&index=0&id=6221d22f&scoped=true&lang=css"
import "./AdminBooks.vue?vue&type=style&index=1&id=6221d22f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6221d22f"]])

export default __exports__